import { AnalyzeService } from '@appStore/analyze/services/analyze.service';

export const services: any[] = [AnalyzeService];

export * from '@appStore/analyze/services/analyze.service';
